import { render } from "./CustomersViews.vue?vue&type=template&id=027e6cde&scoped=true"
import script from "./CustomersViews.vue?vue&type=script&lang=js"
export * from "./CustomersViews.vue?vue&type=script&lang=js"

import "./CustomersViews.vue?vue&type=style&index=0&id=027e6cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027e6cde"]])

export default __exports__